import { EnvironmentProviders, makeEnvironmentProviders, Type } from '@angular/core';

import { BAR_ERROR_HANDLER, BAR_INITIALIZED } from '../constants/internal-tokens.constants';
import { BarErrorHandlerHook } from '../hooks/bar-error-handler.hook';
import { BarInitializedHook } from '../hooks/bar-initialized.hook';

export function provideBaasInitialized<T extends BarInitializedHook>(type: Type<T>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: BAR_INITIALIZED,
            useClass: type,
            multi: true
        }
    ]);
}

export function provideBaasErrorHandler<T extends BarErrorHandlerHook>(type: Type<T>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: BAR_ERROR_HANDLER,
            useClass: type,
            multi: true
        }
    ]);
}
